import useProfile from "./useProfile"
import "./profile.css"
import SelectOption from "../../components/select_option"

import Select from "react-select";
import { axios, decodeToken, errorHandling } from "../../helpers";
import { useSelector } from "react-redux";
import { loginData, logout } from "../../stores/auth";
import debounce from 'lodash.debounce'
import { useCallback } from "react";


const ProfilePage = () => {
    const {
        data,
        isEdit,
        isSync,
        isAdmin,
        formData,
        isLoading,
        isUpdateNik,
        isUpdateKodeSatker,
        isEditSatker,
        isUpdateSatker,
        navigate,
        formDataSatker,
        onUpdateNik,
        handleUpdateNik,
        handleChange,
        handleProfileSync,
        handleChangeFormData,
        onUpdateSatker,
        handleUpdateSatker,
        setFormDataSatker,
        allSatker,
        allSatkerOptions,
        getAllSatker
    } = useProfile()

    const debouncedSearch = useCallback(
        debounce((value) => {
            getAllSatker(value)
        }, 500),
        []
    )
    return (
        <div className="row" style={{ padding: "36px" }}>
            <div className="col-12">
                <h1 className="d-flex justify-content-center mb-4 title-home">Profile</h1>
                <div className="row justify-content-center mb-4">
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12" >
                        <div className="row justify-content-center">
                            <div className="col-3 d-flex justify-content-center">
                                <div className="circle-button" onClick={() => { navigate(-1) }}>
                                    <i className="bi bi-arrow-left"></i> Back
                                </div>
                            </div>
                            {
                                isAdmin ? <></> :
                                    <>
                                        <div className="col-3 d-flex justify-content-center">
                                            <div className="circle-button" onClick={() => { onUpdateNik(isEdit) }}>
                                                {
                                                    isEdit ?
                                                        <i className="bi bi-x-lg"></i> :
                                                        <i className="bi bi-pencil"></i>
                                                }
                                                Update NIK
                                            </div>
                                        </div>
                                        <div className="col-3 d-flex justify-content-center">
                                            <div className="circle-button" onClick={() => handleProfileSync()}>
                                                {
                                                    isSync ?
                                                        <div className="spinner-border mb-2"></div> :
                                                        <i className="bi bi-arrow-clockwise"></i>
                                                }
                                                Sync
                                            </div>
                                        </div>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    {
                        isLoading ?
                            <>Menunggu..</> :
                            <div className="col-xl-6">
                                <div className="d-flex card" style={{
                                    //border: "1px solid black",
                                    //borderRadius: "16px"
                                }}>
                                    <table className="table table-hover">
                                        <tbody>
                                            <tr>
                                                <td >NIP</td>
                                                <td>:</td>
                                                <td>{data.nip}</td>
                                            </tr>
                                            {
                                                isAdmin ? <></> :
                                                    <tr>
                                                        <td>NIK</td>
                                                        <td>:</td>
                                                        <td>
                                                            {
                                                                isEdit ?
                                                                    <div className="d-flex"> <input type="text" name="nik" className="form-control" onChange={handleChange} value={formData.nik} />&nbsp;<button className="btn btn-outline-primary" onClick={() => handleUpdateNik()} disabled={isUpdateNik}>{isUpdateNik ? "Menyimpan..." : "Simpan"}</button> </div> :
                                                                    data.nik
                                                            }
                                                        </td>
                                                    </tr>
                                            }
                                            <tr>
                                                <td>Nama</td>
                                                <td>:</td>
                                                <td>{data.nama_lengkap}</td>
                                            </tr>
                                            <tr>
                                                <td>Email</td>
                                                <td>:</td>
                                                <td>{data.email}</td>
                                            </tr>
                                            <tr>
                                                <td>No. HP</td>
                                                <td>:</td>
                                                <td>{data.no_hp}</td>
                                            </tr>

                                            {
                                                isAdmin ? <></> :
                                                    <tr>
                                                        <td>Status Pegawai</td>
                                                        <td>:</td>
                                                        <td>{data.status_pegawai}</td>
                                                    </tr>
                                            }
                                            {/* {
                                                isAdmin ? <></> :
                                                    <tr>
                                                        <td>Satuan Kerja</td>
                                                        <td>:</td>
                                                        <td>{data.satuan_kerja}</td>
                                                    </tr>
                                            } */}
                                            {
                                                isAdmin ? <></> :
                                                    <tr>
                                                        <td>Satuan Kerja</td>
                                                        <td>:</td>
                                                        <td>
                                                            <Select
                                                                options={allSatkerOptions}
                                                                name="kode_satker_utama"
                                                                id="kode_satker_utama"
                                                                value={formDataSatker.kode_satker_utama}
                                                                onChange={(e) => {
                                                                    setFormDataSatker({ ...formDataSatker, kode_satker_utama: e })
                                                                }}
                                                                onInputChange={(inputValue, { action }) => {
                                                                    if (action === 'input-change') {
                                                                        debouncedSearch(inputValue)
                                                                    }
                                                                }}

                                                                placeholder="Satuan Kerja Utama..."
                                                                isDisabled={isEditSatker}
                                                                isClearable
                                                            />

                                                            {/*                                                             
                                                                        <Select
                                                                        options={allSatkerOptions}
                                                                            name={"kode_satker_utama"}
                                                                            id={"kode_satker_utama"}
                                                                    value={formDataSatker.kode_satker_utama}
                                                                    onChange={(e)=>{
                                                                        console.log(e)
                                                                        setFormDataSatker({...formDataSatker,kode_satker_utama:e})
                                                                    }}
                                                                placeholder={"Satuan Kerja Utama..."}
                                                                            // required={required}
                                                                            // isClearable={false}
                                                                            isDisabled={isEditSatker}
                                                                        /> */}
                                                            {/* <SelectOption
                                                                to={"kode_satker_utama"}
                                                                url={"/v1/satker"}
                                                                fromAccount={true}
                                                                placeholder={"Satuan Kerja Utama..."}
                                                                selectedOption={selectedOptionDari}
                                                                isDisabled={isEditSatker}
                                                                handleChangeSelectOption={handleChangeFormData}
                                                            /> */}
                                                            {/* &nbsp; */}
                                                            <button className="mt-2 btn btn-outline-primary" onClick={() => handleUpdateSatker()}
                                                                disabled={isUpdateKodeSatker}>{isUpdateKodeSatker ? "Menyimpan..." : "Simpan"}</button>
                                                        </td>
                                                    </tr>
                                            }
                                            {
                                                isAdmin ? <></> :
                                                    <tr>
                                                        <td>Status Sertifikat</td>
                                                        <td>:</td>
                                                        <td>
                                                            {
                                                                data.status_se ?
                                                                    <div className="text-success">Status Sertifikat Anda ISSUE</div> :
                                                                    <div className="text-danger">Pengguna tidak terdaftar / Sertifikat Elektronik telah Expired</div>
                                                            }
                                                        </td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                    }
                </div>
            </div>
            {/* <div className="col-lg-12 ">
                {
                    isLoading ?
                        <>Menunggu..</> :
                        <div className="row d-flex justify-content-center" style={{
                            background: "grey"
                        }}>
                            <div className="col-xl-4 col-lg-4">NIP</div>
                            <div className="col-xl-4 col-lg-4">:</div>
                            <div className="col-xl-4 col-lg-4">{data.nip}</div>


                            <div className="col-xl-4 col-lg-4">NIK</div>
                            <div className="col-xl-4 col-lg-4">:</div>
                            <div className="col-xl-4 col-lg-4">{data.nik}</div>


                            <div className="col-xl-4 col-lg-4">Nama</div>
                            <div className="col-xl-4 col-lg-4">:</div>
                            <div className="col-xl-4 col-lg-4">{data.nama_lengkap}</div>


                            <div className="col-xl-4 col-lg-4">No. Hp</div>
                            <div className="col-xl-4 col-lg-4">:</div>
                            <div className="col-xl-4 col-lg-4">{data.no_hp}</div>


                            <div className="col-xl-4 col-lg-4">Email</div>
                            <div className="col-xl-4 col-lg-4">:</div>
                            <div className="col-xl-4 col-lg-4">{data.email}</div>

                        </div>
                }
            </div> */}
        </div>
    )
}
export default ProfilePage